import { createSlice } from "@reduxjs/toolkit";
import { getAdminMangerDataAction } from "../../actions";

export interface IAdminManagerData {
    users: any
    businesses: any
    config: any
}

interface IAdminBusinessState {
    adminManagerData: IAdminManagerData | null;
    adminManagerDataLoading: boolean
}

const initialState: IAdminBusinessState = {
    adminManagerData: null,
    adminManagerDataLoading: false
}

const adminBusinessSlice = createSlice({
    name: "adminBusiness",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder

            // get admin manager data 
            .addCase(getAdminMangerDataAction.pending, (state) => {
                state.adminManagerDataLoading = true
                state.adminManagerData = null
            })
            .addCase(getAdminMangerDataAction.fulfilled, (state, action) => {
                state.adminManagerDataLoading = false
                state.adminManagerData = action.payload.data
            })
            .addCase(getAdminMangerDataAction.rejected, (state) => {
                state.adminManagerDataLoading = true
                state.adminManagerData = null
            })
    }
})

export default adminBusinessSlice.reducer